export default "__VITE_ASSET__bPVjRh_Q__"